import { render, staticRenderFns } from "./DadosCompraDialog.vue?vue&type=template&id=2c37f668&scoped=true&"
import script from "./DadosCompraDialog.vue?vue&type=script&lang=js&"
export * from "./DadosCompraDialog.vue?vue&type=script&lang=js&"
import style0 from "./DadosCompraDialog.vue?vue&type=style&index=0&id=2c37f668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c37f668",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VCol,VContainer,VDialog,VProgressLinear,VRow,VSelect,VTextField})
